module.exports = __webpack_public_path__ + "static/media/p.4a08625d.svg";